import { create } from '@storybook/theming/create';
import logo from './logo.svg'

export default create({
  base: 'dark',

  colorPrimary: '#f2788f',
  colorSecondary: '#73cac4',

  // UI
  appBg: '#262626',
  appContentBg: 'white',
  appBorderColor: 'white',
  appBorderRadius: 5,

  // Typography
  fontBase: '"Gilroy", sans-serif',
  fontCode: 'monospace',

  // Text colors
  textColor: 'white',
  textInverseColor: 'white',

  // Toolbar default and active colors
  barTextColor: 'white',
  barSelectedColor: 'white',
  barBg: '#262626',

  // Form colors
  inputBg: 'white',
  inputBorder: 'white',
  inputTextColor: 'white',
  inputBorderRadius: 0,

  brandTitle: 'Unc Inc Kitchensink',
  brandUrl: '/',
  brandImage: logo,
});
